module.exports = __webpack_public_path__ + "img/dcmm_19.6bd02e1e.png";